import './StatsSection.css';

const stats = [
  { value: "60+", label: "Clients" },
  { value: "660+", label: "Projects" },
  { value: "80+", label: "Innovations" },
  { value: "110+", label: "Team Members" },
  { value: "13+", label: "Experience" },
];

export default function StatsSection() {
  return (
    <section className="stats-section">
      <div className="stats-card">
        {stats.map((stat, index) => (
          <div className="stat-item" key={index}>
            <h3 className="stat-value">{stat.value}</h3>
            <p className="stat-label">{stat.label}</p>
            {index !== stats.length - 1 && <span className="stat-divider" />}
          </div>
        ))}
      </div>
    </section>
  );
}